import { render, staticRenderFns } from "./Round.vue?vue&type=template&id=106ff295&scoped=true&"
import script from "./Round.vue?vue&type=script&lang=js&"
export * from "./Round.vue?vue&type=script&lang=js&"
import style0 from "./Round.vue?vue&type=style&index=0&id=106ff295&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106ff295",
  null
  
)

export default component.exports